<template>
  <div>
    <!--    TODO -->
    <div class='table' v-if="!loadingData && serverData">
      <div class='table__item table__item-header without-line left-line right-line bottom-line'>Показатели</div>
      <div class='table__item table__item-header left-line right-line bottom-line text-center'>за {{baseYear-3}} г</div>
      <div class='table__item table__item-header left-line right-line bottom-line text-center'>за {{baseYear-2}} г</div>
      <div class='table__item table__item-header left-line right-line bottom-line text-center right-line'>за {{baseYear-1}} г
      </div>
      
      <div class='table__item pa-0 table__item-header without-line2 left-line right-line bottom-line'>1</div>
      <div class='table__item pa-0 table__item-header left-line bottom-line text-end pr-2'>2</div>
      <div class='table__item pa-0 table__item-header bottom-line left-line text-center'>3</div>
      <div class='table__item pa-0 table__item-header bottom-line left-line text-center'>4</div>
      <div class='table__item pa-0 table__item-header bottom-line left-line text-center right-line'>5</div>
      
      <div class='table__item without-line3 without-line-height left-line right-line bottom-line'>
        Профессорско-преподавательский состав
      </div>
      <div class='table__item left-line right-line bottom-line'>среднесписочная численность (без внешних
        совместителей)
      </div>
      <div class='table__item left-line bottom-line text-end'>человек</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="(item, index) in dataFields.slice(0,3)" :key="item.name">
        <fives-table-cell-dop v-if="index>1"
                              :disabled="organizationBlocked" :cell="{dataField: item.name}"
                              :row="{id: serverData.id, kcpGroup: null, orgId: serverData.orgId}" :value="parseFloatFromString(serverData[item.name])"
                              @change-value-dop="dopChanges($event)"
        ></fives-table-cell-dop>
        <fives-table-cell v-else
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item left-line right-line bottom-line'>внешних совместителей (в пересчете на полную
        занятость)
      </div>
      <div class='table__item left-line bottom-line text-end'>человек</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="(item, index) in dataFields.slice(3,6)" :key="item.name">
        <fives-table-cell-dop v-if="index>1"
                              :disabled="organizationBlocked"
                              :key="item.name" :cell="{dataField: item.name}"
                              :row="{id: serverData.id, kcpGroup: null, orgId: serverData.orgId}" :value="parseFloatFromString(serverData[item.name])"
                              @change-value-dop="dopChanges($event)"
        ></fives-table-cell-dop>
        <fives-table-cell v-else
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item left-line without-line4 right-line bottom-line'>Работники, выполнявшие НИР - исследователи
        (на конец года без внешних совместителей)
      </div>
      <div class='table__item left-line bottom-line text-end'>человек</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="(item, index) in dataFields.slice(6,9)" :key="item.name">
        <fives-table-cell-dop v-if="index>1"
                              :disabled="organizationBlocked"
                              :key="item.name" :cell="{dataField: item.name}"
                              :row="{id: serverData.id, kcpGroup: null, orgId: serverData.orgId}" :value="parseFloatFromString(serverData[item.name])"
                              @change-value-dop="dopChanges($event)"
        ></fives-table-cell-dop>
        <fives-table-cell v-else
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item left-line without-line4 right-line bottom-line'>Выполнено работ, услуг, произведено
        товаров, всего (без НДС, акцизов и других подобных платежей)
      </div>
      <div class='table__item left-line bottom-line text-end'>тыс.рублей</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="(item, index) in dataFields.slice(9,12)" :key="item.name">
        <fives-table-cell-dop v-if="index>1"
                              :disabled="organizationBlocked"
                              :key="item.name" :cell="{dataField: item.name}"
                              :row="{id: serverData.id, kcpGroup: null, orgId: serverData.orgId}" :value="parseFloatFromString(serverData[item.name])"
                              @change-value-dop="dopChanges($event)"
        ></fives-table-cell-dop>
        <fives-table-cell v-else
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item left-line right-line top-line bottom-line'></div>
      <div class='table__item left-line right-line bottom-line text-end'>в том числе:</div>
      <div class='table__item left-line right-line  bottom-line'> исследования и разработки</div>
      <div class='table__item left-line bottom-line text-end'>тыс.рублей</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="(item, index) in dataFields.slice(12,15)" :key="item.name">
        <fives-table-cell-dop v-if="index>1"
                              :disabled="organizationBlocked"
                              :key="item.name" :cell="{dataField: item.name}"
                              :row="{id: serverData.id, kcpGroup: null, orgId: serverData.orgId}" :value="parseFloatFromString(serverData[item.name])"
                              @change-value-dop="dopChanges($event)"
        ></fives-table-cell-dop>
        <fives-table-cell v-else
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item without-line2 left-line bottom-line right-line'>Внутренние затраты на научные исследования
        и разработки, всего
      </div>
      <div class='table__item left-line bottom-line text-end'>тыс.рублей</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="(item, index) in dataFields.slice(15, 18)" :key="item.name">
        <fives-table-cell-dop v-if="index>1"
                              :disabled="organizationBlocked"
                              :key="item.name" :cell="{dataField: item.name}"
                              :row="{id: serverData.id, kcpGroup: null, orgId: serverData.orgId}" :value="parseFloatFromString(serverData[item.name])"
                              @change-value-dop="dopChanges($event)"
        ></fives-table-cell-dop>
        <fives-table-cell v-else
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item left-line right-line top-line bottom-line'></div>
      <div class='table__item right-line left-line bottom-line text-end'>в том числе:</div>
      <div class='table__item left-line right-line bottom-line'>собственные средства</div>
      <div class='table__item left-line bottom-line text-end'>тыс.рублей</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="(item, index) in dataFields.slice(18,21)" :key="item.name">
        <fives-table-cell-dop v-if="index>1"
                              :disabled="organizationBlocked"
                              :key="item.name" :cell="{dataField: item.name}"
                              :row="{id: serverData.id, kcpGroup: null, orgId: serverData.orgId}" :value="parseFloatFromString(serverData[item.name])"
                              @change-value-dop="dopChanges($event)"
        ></fives-table-cell-dop>
        <fives-table-cell v-else
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item left-line top-line right-line'></div>
      <div class='table__item left-line right-line top-line'></div>
      <div class='table__item left-line right-line'>средства бюджетов всех уровней</div>
      <div class='table__item left-line text-end'>тыс.рублей</div>
      <div class='table__item left-line item-data text-center d-flex flex-row align-center justify-space-around'
           v-for="(item, index) in dataFields.slice(21,24)" :key="item.dataField">
        <fives-table-cell-dop v-if="index>1"
                              :disabled="organizationBlocked"
                              :key="item.name" :cell="{dataField: item.name}"
                              :row="{id: serverData.id, kcpGroup: null, orgId: serverData.orgId}" :value="parseFloatFromString(serverData[item.name])"
                              @change-value-dop="dopChanges($event)"
        ></fives-table-cell-dop>
        <fives-table-cell v-else
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      <div
        class='table__item without-line5 top-line bottom-line left-line right-line bottom-line background font-size-small__important'>
        Примечание: значения численности профессорско-преподавательского состава предварительно заполнены
        <!--по данным ВПО- -->на 1 октября соответствующего года
      </div>
    </div>
    <div v-else-if="loadingData" class="d-flex flex-row align-center justify-center" style="min-width: 150px;">
      <v-progress-linear indeterminate/>
    </div>
    <appeal-dialog
      ref="appeal-dialog"
      :appeal-id="appealId"
      :file-id="fileId"
      :appeal="appealCell"
      :value="appealValue"
      :appeal-info="appealInfo"
      @saved-value="saveValue($event)"
      @closing-dialog="closingAppealDialog"
    ></appeal-dialog>
    <tooltip-forms5-dialog
      ref="tooltip-dialog"
      :data-field="dataFieldTooltip"
    >
    </tooltip-forms5-dialog>
  </div>
</template>

<script>

import {setAppealFromOneToFourDialog} from "@/mixins/forms5/appealDialogF1-4";
import FivesTableCell from "@/components/fields/fivesTableCell";
import appealDialog from "@/components/Dialogs/appealForms5_1-4Dialog";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import tooltipForms5Dialog from "@/components/Dialogs/tooltipForms5Dialog";
import {fiveFormsMixin} from "@/mixins/formUsl";
import Form5Controller from "@/controllers/Organizations/Form5Controller";
import {mapActions, mapGetters} from "vuex";
import fivesTableCellDop from "@/components/fields/fivesTableCellDop.vue";

export default {
  name: "form5_1c",
  mixins: [setAppealFromOneToFourDialog, headerTooltipFunctions, fiveFormsMixin],
  components: {fivesTableCellDop, FivesTableCell, appealDialog, tooltipForms5Dialog},
  props: {
    baseYear: {
      type: Number,
      required: true
    },
    chosenChildOrg: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
  },
  
  data() {
    return {
      serverData: null,
      loadingData: false,
      loadingMenu: {value: false, id: ''},
      dataFields: [
        {name: 'wpppo20Vp1',},
        {name: 'wpppo21Vp1',},
        {name: 'wpppo22Vp1',},
        {name: 'wppps20Vp1',},
        {name: 'wppps21Vp1',},
        {name: 'wppps22Vp1',},
        {name: 'wprdo20Nu2',},
        {name: 'wprdo21Nu2',},
        {name: 'wprdo22Nu2',},
        {name: 'dsorg20Nu2',},
        {name: 'dsorg21Nu2',},
        {name: 'dsorg22Nu2',},
        {name: 'dsnir20Nu2',},
        {name: 'dsnir21Nu2',},
        {name: 'dsnir22Nu2',},
        {name: 'dsvnz20Nu2',},
        {name: 'dsvnz21Nu2',},
        {name: 'dsvnz22Nu2',},
        {name: 'dssfs20Nu2',},
        {name: 'dssfs21Nu2',},
        {name: 'dssfs22Nu2',},
        {name: 'dssbs20Nu2',},
        {name: 'dssbs21Nu2',},
        {name: 'dssbs22Nu2'}
      ]
      
    }
  },
  computed: {
    ...mapGetters('spr', {getChosenOrgId: 'getChosenOrgId'}),
  },
  created() {
    this.appealInfo.nameForm = 'FORM5_1C'
    if (this.get_spr_data_usl_loading === false)
      this.loadingDataTable();
  },
  watch: {
    getChosenOrgId() {
      this.loadingDataTable();
    }
  },
  methods: {
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    parseFloatFromString(value) {
      if (value) {
        let newValue = Number(value.replace(",", "."));
        if (isNaN(newValue)) return value;
        return newValue;
      }
      return value
    },
    async loadingDataTable() {
      this.loadingData = true;
      try {
        this.serverData = await Form5Controller.getForm('part1v', false, false, this.chosenChildOrg?.id);
        this.loadingData = false;
      } catch (e) {
        await this.addNotification({
          notificationStatus: 'error',
          notificationMessage: 'Нет данных',
          timeout: 5000
        })
        this.loadingData = false;
      }
    },
    calcPropsForCell(dataField) {
      return {
        value: this.serverData[dataField],
        title: '',
        cell: {dataField: dataField},
        id: this.serverData.id,
        row: this.serverData,
        loading: this.loading,
        template: (v) => {
          if (v == null || v === 'н.д.')
            return 'н.д.';
          const dot = v.indexOf(',');
          if (dot !== -1) {
            const newV = v.slice(0, dot) + '.' + v.slice(dot + 1, dot + 2);
            return Intl.NumberFormat('ru-RU').format(Number.parseFloat(newV));
          } else
            return Intl.NumberFormat('ru-RU').format(Number.parseFloat(v));
        }
        
      }
    },
    dopChanges(e) {
      const searchIndex = this.serverData.findIndex(el => el.id === e.id);
      this.serverData.splice(searchIndex, 1, {...this.serverData[searchIndex], [e.dataField]: e.value});
    },
  },
}
</script>

<style lang="scss" scoped>
.table {
  display: grid;
  grid-template-columns: 100px 2fr 1fr 1fr minmax(100px, 200px) minmax(100px, 200px) minmax(100px, 200px);
  color: #89A0B0;
  background-color: #FFFFFF;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgb(0 0 0 / 6%);
  margin-bottom: 20px;
  padding: 12px;
  margin-right: auto;
  margin-left: auto;
  overflow: auto;
  
  &::-webkit-scrollbar {
    height: 8px;
  }
  
}

.table__item-header {
  font-size: 12px;
}

.table__item {
  padding: 5px;
  font-size: 14px;
  border: 1px solid #CFD8DC;
  
  &:not(.table__item-header) {
    color: #455A64
  }
}

.table__header {
  border-top: 1px solid #CFD8DC;
}

.without-line {
  grid-column-start: 1;
  grid-column-end: 5;
}

.without-line2 {
  grid-column-start: 1;
  grid-column-end: 4;
}

.without-line3 {
  grid-column-start: 1;
  grid-column-end: 3;
}

.without-line-height {
  grid-row-start: 3;
  grid-row-end: 5;
}

.without-line4 {
  grid-column-start: 1;
  grid-column-end: 4;
}

.without-line5 {
  grid-column-start: 1;
  grid-column-end: 8;
}

.top-line {
  border-top: none;
}

.left-line {
  border-left: none;
}

.bottom-line {
  border-bottom: none;
}

.right-line {
  border-right: none;
}

.close {
  top: 95px;
  right: 90px;
}

.old__item {
  text-decoration: line-through;
  font-size: 35px;
}

.new__item {
  background: #E3EFFA;
  border-radius: 7px;
  height: 55px;
  width: 190px;
  padding-left: 20px;
  padding-right: 20px;
}

.new__item::placeholder {
  font-size: 20px;
  align-items: center;
  
}

.items {
  display: flex;
  justify-content: space-between;
  padding: 0 120px;
  margin-top: 13%;
}

.item-data:hover {
  background: rgba(207, 224, 236, 0.42);
}

.background-left {
  border-top-left-radius: 10px;
}

.background-right {
  border-top-right-radius: 10px;
}
</style>